module.exports = __webpack_public_path__ + "static/lframe-kiwibank-home-renovation-a6a6865f0bf093b4681d01e2ca3bae2b.webp";